import React from 'react';
import styled from 'styled-components';
import RichTextHtmlWrapper from 'shared/components/rich-text-html-wrapper';
import { getDescriptionHtml } from 'shared/utils/product-description-utils';
import { Description } from '../../typography';

export default function ProductDescription({ product, isFirstSection, isLastSection }) {
  return (
    <Container>
      <StyledDescription isFirstSection={isFirstSection} isLastSection={isLastSection}>
        <RichTextHtmlWrapper html={getDescriptionHtml(product)} />
      </StyledDescription>
    </Container>
  );
}

const Container = styled.div`
  font-family: var(--dct--customized-fonts-secondary);

  > img {
    display: block;
    margin-bottom: 21px;
    max-width: 207px;
    object-fit: scale-down;
  }
`;

const StyledDescription = styled(Description)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    font-size: 12px;
  }
  p {
    margin-bottom: ${({ isLastSection }) => (isLastSection ? `0px` : `22px`)};
  }
`;
